import KeyboardTabRoundedIcon from '@mui/icons-material/KeyboardTabRounded';
import { Box, IconButton } from '@mui/material';
import type { ReactNode } from 'react';
import { styles } from './Header.styles';

type DesktopHeaderFrameProps = {
  children: ReactNode;
  isSidebarCompact: boolean;
  showSidebarCollapse: boolean;
  testId: string;
  contentTestId?: string;
  sidebarSlotTestId?: string;
  toggleSidebarCompact?: () => void;
};

const DesktopHeaderFrame = ({
  children,
  contentTestId,
  isSidebarCompact,
  showSidebarCollapse,
  sidebarSlotTestId,
  testId,
  toggleSidebarCompact,
}: DesktopHeaderFrameProps) => (
  <Box sx={styles.authDesktopInner} data-testid={testId}>
    {showSidebarCollapse ? (
      <Box sx={styles.desktopSidebarSlot(isSidebarCompact)} data-testid={sidebarSlotTestId}>
        <IconButton
          data-testid='neobet-sidebar-collapse-toggle'
          sx={styles.utilityIconButton()}
          onClick={toggleSidebarCompact}
        >
          <KeyboardTabRoundedIcon sx={{ transform: isSidebarCompact ? 'none' : 'rotate(180deg)' }} fontSize='small' />
        </IconButton>
      </Box>
    ) : null}

    <Box sx={styles.desktopContentContainer} data-testid={contentTestId}>
      {children}
    </Box>
  </Box>
);

export default DesktopHeaderFrame;
